// externals
import type { PropsWithChildren } from 'react';
import React from 'react';
import type { RouterProps as TypedRouterProps } from 'react-router-dom';
import { Router as TypedRouter } from 'react-router-dom';

const TypelessRouter = TypedRouter as any;

export type RouterProps = PropsWithChildren<TypedRouterProps>;

export const Router: React.FC<RouterProps> = (props) => <TypelessRouter {...props}>{props.children}</TypelessRouter>;
